import React from 'react';
import { Form, Input, message, Modal } from 'antd';
import common from "@/assets/common.js";
import './password.css';

const FormItem = Form.Item;

class Password extends React.Component {
  state = {
    time: new Date().getTime(),
  }
  handleSubmit = () => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let done = true;
        common.eachObj(values, function(key, value){
          switch(key){
            case "repassword":
              delete values[key];
              if(value !== values["newPassWord"]) {
                message.warning("请重复输入新密码");
                done =false;
              }
              break;
            default:
              break;
          }
        });
        if(!done) return;
        this.setPassword(values);
      }
    });
  }
  setPassword = (values) => {
    var postData = values;
    postData["_url"] = "admin/update/self/password";
    postData["adminId"] = window.info.adminId;
    common.request(postData, this, function(obj, data){
      message.info("修改成功");
      obj.props.showModal("")
      // setTimeout(function(){
      //   obj.props.history.push('login');
      // }, 2000)
    }, function(obj, data){
      message.error(data.message);
    })
  }
  validPass = (rule, value, callback) => {
    const pass = this.props.form.getFieldValue("newPassWord");
    const oldPass = this.props.form.getFieldValue("repassword");
    if (pass === oldPass || pass === "") {
      callback();
    } else {
      callback('请重复输入密码');
    }
  }
  validatePwd = (rule, value, callback) => {
    if (!(/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,16}$))/.test(value))) {
      callback('请输入8-16位字符，至少包含数字、大写字母、小写字母、特殊字符中的三种类型');
    } else {
      callback();
    }
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout =  {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 15 },
        sm: { span: 15 },
      },
    };
    // const formItemLayout = {
    //    wrapperCol: {
    //      xs: { span: 24 },
    //      sm: { span: 24 },
    //    },
    //  };
    return (
      <Modal
        className="passwordModal"
        title="修改密码"
        visible={ this.props.modalType === "passWord" }
        onOk={ () => this.handleSubmit() }
        onCancel={() => this.props.showModal("") }
        okText="修改"
      >
        <div id="passwordDiv">
          <div  id="passwordContent">
            <Form onSubmit={this.handleSubmit} id="passWordForm" className="form-login">
              <FormItem
                label="登录密码"
                { ... formItemLayout }
              >
                {getFieldDecorator('passWord', {
                  rules: [{ required: true, message: '请输入登录密码' }],
                })(
                  <Input type="password" placeholder="请输入登录密码" />
                )}
              </FormItem>
              <FormItem
                label="新密码"
                { ... formItemLayout }
              >
                {getFieldDecorator('newPassWord', {
                  initialValue: "",
                  rules: [{ required: true, message: '请输入新密码' },{ min : 8, message : "密码至少8~16位"},{
                    validator: this.validatePwd
                  }],
                })(
                  <Input type="password" placeholder="请输入新密码" />
                )}
              </FormItem>
              <FormItem
                label="重复新密码"
                { ... formItemLayout }
              >
                {getFieldDecorator('repassword', {
                  initialValue: "",
                  rules: [{
                    required: true, message: '请重复输入新密码',
                  },this.validPass,],
                })(
                  <Input type="password" placeholder="请重复输入新密码" />
                )}
              </FormItem>
            </Form>
          </div>
        </div>
      </Modal>
    );
  }
}

const PasswordForm = Form.create()(Password);
export default PasswordForm;



// WEBPACK FOOTER //
// ./src/index/password/passwordmodal.js